import { EyeOutlined } from '@ant-design/icons';
import { Button, Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';
import { resolveApiPath } from '../../../../../core/appConfig.ts';
import { type IPublicAreaFile } from './getTableTreeDataFromCartelle.tsx';

export interface IPublicFileDownloadButtonProps {
  record: IPublicAreaFile;
}

export function PublicFileDownloadButton(
  props: IPublicFileDownloadButtonProps,
) {
  const { record } = props;
  const { t } = useTranslation();

  return (
    <Tooltip
      title={t(
        'observation-details.apri-documento',
        `Apri Documento {{record}}`,
        { record: record.nome ? `"${record.nome}"` : '' },
      )}
    >
      <Button
        type="link"
        size="large"
        aria-label={`Apri Documento ${record.nome}`}
        icon={<EyeOutlined aria-hidden />}
        target="_blank"
        rel="noopener noreferrer"
        href={resolveApiPath(record.url!)}
      />
    </Tooltip>
  );
}
